import { useDragComponentsPlaceholder } from '../../../utils/use-drag-components-placeholder';

import { UseCasesGrid } from '../use-cases-grid/use-cases-grid';
import { UseCasesContentBlockContainerProps } from './use-cases-content-block-container.config';

const UseCasesContentBlockContainer = ({
  accessibilityLabel,
  additionalClasses,
  appliedCssClassNames,
  cqItems,
  cqItemsOrder,
  cqPath,
  id,
  isInEditor,
  roleAttribute,
}: UseCasesContentBlockContainerProps) => {
  const { placeholder } = useDragComponentsPlaceholder({ cqPath, isInEditor });

  return (
    <div
      aria-label={accessibilityLabel}
      className={additionalClasses}
      data-testid="use-cases-row-grid-container"
      id={id}
      role={roleAttribute}
    >
      <UseCasesGrid
        cqPath={cqPath}
        cqItems={cqItems}
        cqItemsOrder={cqItemsOrder}
        appliedCssClassNames={appliedCssClassNames}
      />
      {placeholder}
    </div>
  );
};

export default UseCasesContentBlockContainer;
